export const en = {
  'LoginButton.Label': 'Sign in with Zucchetti Hospitality',
  'LoginButton.Loading': 'Signing in…',
  'LoginButton.InfoTitle': 'What are Zucchetti Hospitality credentials?',
  'LoginButton.InfoDescription':
    'This is your single Zucchetti Hospitality account, provided by ZIdentity, used to access enabled services. Use the same company credentials you already use in other Zucchetti Hospitality applications.',
  'StepUp.Brand': 'Zucchetti Hospitality',
  'StepUp.Title': 'Verify your identity',
  'StepUp.Totp.Prompt':
    'This action requires extra verification. Enter the authenticator code for your Zucchetti Hospitality account to continue.',
  'StepUp.Totp.CodeLabel': 'Authenticator code',
  'StepUp.EmailOtp.Prompt':
    'This action requires extra verification. We sent a verification code to the email address of your Zucchetti Hospitality account. Enter it below to continue.',
  'StepUp.EmailOtp.CodeLabel': 'Verification code',
  'StepUp.EmailOtp.NoCode': "Didn't receive a code?",
  'StepUp.EmailOtp.Resend': 'Resend',
  'StepUp.Submit': 'Verify',
  'StepUp.Discovering': 'Loading…',
  'StepUp.Submitting': 'Verifying…',
  'StepUp.Cancel': 'Cancel',
  'StepUp.Close': 'Close',
  'StepUp.Error.InvalidCode': 'Invalid code. Please try again.',
  'StepUp.Error.RateLimited': 'Too many attempts. Please try again later.',
  'StepUp.Error.InvalidAccessToken': 'Your session has expired. Please sign in again.',
  'StepUp.Error.NotEnabled': 'Step-up verification is not available for this application.',
  'StepUp.Error.Network': 'Something went wrong. Please check your connection and try again.',
} as const
